import request from '@/axios/request.js'
// 查询通知公告列表
export function getNoticeInfoPageList(params) {
  return request({
    url: '/mall/notice/getNoticeInfoPageList',
    method: 'get',
    params
  })
}
// 增加通知公告
export function addNoticeInfo(data) {
  return request({
    url: '/mall/notice/addNoticeInfo',
    method: 'post',
    data
  })
}
// 修改通知公告
export function updateNoticeInfo(data) {
  return request({
    url: '/mall/notice/updateNoticeInfo',
    method: 'post',
    data
  })
}
// 删除通知公告
export function noticeDel(id) {
  return request({
    url: 'mall/notice/delNoticeInfo/' + id,
    method: 'put'
  })
}
// 查询通知公告详情
export function getNoticeInfo(id) {
  return request({
    url: 'mall/notice/getNoticeInfo/' + id,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/notice.js